var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickFeaturedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 28C4.5 14.7452 15.2452 4 28.5 4V4C41.7548 4 52.5 14.7452 52.5 28V28C52.5 41.2548 41.7548 52 28.5 52V52C15.2452 52 4.5 41.2548 4.5 28V28Z",
    fill: "#D1FADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 27.08V28C38.4988 30.1564 37.8005 32.2547 36.5093 33.9818C35.2182 35.709 33.4033 36.9725 31.3354 37.5839C29.2674 38.1953 27.0573 38.1219 25.0345 37.3746C23.0117 36.6273 21.2846 35.2461 20.111 33.4371C18.9373 31.628 18.3798 29.4881 18.5217 27.3363C18.6636 25.1846 19.4972 23.1363 20.8983 21.4971C22.2993 19.8578 24.1928 18.7154 26.2962 18.2401C28.3996 17.7649 30.6003 17.9823 32.57 18.86M38.5 20L28.5 30.01L25.5 27.01",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 48C17.4543 48 8.5 39.0457 8.5 28H0.5C0.5 43.464 13.036 56 28.5 56V48ZM48.5 28C48.5 39.0457 39.5457 48 28.5 48V56C43.964 56 56.5 43.464 56.5 28H48.5ZM28.5 8C39.5457 8 48.5 16.9543 48.5 28H56.5C56.5 12.536 43.964 0 28.5 0V8ZM28.5 0C13.036 0 0.5 12.536 0.5 28H8.5C8.5 16.9543 17.4543 8 28.5 8V0Z",
    fill: "#ECFDF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFeaturedIcon);
export default __webpack_public_path__ + "static/media/tickFeaturedIcon.b63642a4c04a52a444562ffae325b6fb.svg";
export { ForwardRef as ReactComponent };